import type { ProgramDialInInformation } from 'models';
import type { EventActionsView } from '../../../types';
import { EventButtonsListLayout } from '../event-buttons-list-layout';
import { EventDialInButton } from './event-dial-in-button';
import { EventJoinButton } from './event-join-button';
import { EventJoinButtonsDetailLayout } from './event-join-buttons-detail-layout';

export type EventJoinButtonsProperties = {
  dialInData?: ({ href: string } & ProgramDialInInformation) | null;
  isJoining: boolean;
  onEnter: () => void;
};

type P = {
  joinButton: EventJoinButtonsProperties;
  view: EventActionsView;
};

const EventJoinButtons = ({ joinButton, view }: P) => {
  const { dialInData, isJoining, onEnter } = joinButton;

  switch (view) {
    case 'detail':
      return (
        <EventJoinButtonsDetailLayout
          left={<EventJoinButton block loading={isJoining} onEnter={onEnter} size="large" />}
          right={dialInData ? <EventDialInButton block dialInData={dialInData} size="large" /> : null}
        />
      );
    case 'header':
      return null;
    case 'list':
      return (
        <EventButtonsListLayout
          gutter="xxs"
          left={<EventJoinButton loading={isJoining} onEnter={onEnter} size="small" />}
          right={dialInData ? <EventDialInButton dialInData={dialInData} size="small" /> : null}
        />
      );
  }
};

export default EventJoinButtons;
